import HeaderWithIcons from '@components/app/HeaderWithIcons';
import {ICompetition} from '@components/competitions/ICompetitions';
import {appConfig} from '@config';
import {CompetitionAhdContext} from '@context/CompetitionAhdContext';
import {Box} from '@mui/material';
import socketCompetition from '@sockets/competition';
import axios from 'axios';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useLoaderData, useLocation} from 'react-router-dom';
import Mission0 from './Mission0';

export default function Ahd() {
	let referrer = '',
		socialGroup = '';
	const {t} = useTranslation();
	const location = useLocation();
	
	if (location.state) {
		referrer = location.state?.referrer ?? '';
		if (referrer === 'shad') {
			socialGroup = 'shad';
		}
	}
	
	const [competition, setCompetition] = useState<ICompetition>({});
	const [mission, setMission] = useState<number>(0);
	const [phone, setPhone] = useState<string>('');
	
	const competitionObject = useLoaderData() as ICompetition;
	
	// useEffect(() => {
	// 	socketCompetition.connect();
	// }, []);
	
	useEffect(() => {
		setCompetition(competitionObject);
	}, [competitionObject]);
	
	return (
		<CompetitionAhdContext.Provider
			value={{
				competition,
				mission,
				setMission,
				phone,
				setPhone
			}}
		>
			<Box className="w-full flex justify-center flex-col">
				{/*<HeaderWithIcons*/}
				{/*	title={competition.name ?? 'پویش بزرگ "عهد"!'}*/}
				{/*	home={true}*/}
				{/*	backUrl={'/'}*/}
				{/*/>*/}
				<Box
					// className="ahd-bg flex flex-col w-full h-[calc(100vh-55px)] bg-no-repeat overflow-y-scroll justify-center">
					className="ahd-bg flex flex-col w-full h-screen bg-no-repeat overflow-y-scroll justify-center">
					<Mission0/>
				</Box>
			</Box>
		</CompetitionAhdContext.Provider>
	);
}

interface loader {
	request: Request;
	params: {};
}

export async function ahdLoader(data: loader) {
	const res = await axios({
		// @ts-ignore
		url: `${appConfig.competition2.url}ahd/${data.params.competitionId}`,
		method: 'GET'
	});
	
	if (res.data.success) {
		return res.data.result;
	} else {
		return res.data.error;
	}
}
